import React from "react";
import { Button, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom"; // Opcional si usas React Router

const CustomButton = () => {
  return (
    <Box sx={{ position: "relative", width: { xs: "100%", md: "fit-content" } }}>
      <Button
        component={Link}
        to="/registry"
        variant="contained"
        sx={{
          bgcolor: "black",
          color: "white",
          borderRadius: "999px",
          height: "48px",
          width: { xs: "100%", md: "fit-content" },
          px: 3,
          py: 1,
          border: "1.5px solid black",
          fontWeight: 600,
          fontSize: "1.125rem",
          fontFamily: "'Roboto Flex', sans-serif",
          display: "flex",
          justifyContent: "space-between",
          gap: 2,
          "&:hover": { bgcolor: "#222" }
        }}
      >
        <span>Comienza ahora</span>
        <span>→</span>
      </Button>

      <Typography
        variant="body2"
        sx={{
          color: "grey.700",
          textAlign: "center",
          mt: 1
        }}
      >
        Pausa o cancela cuando quieras.
      </Typography>
    </Box>
  );
};

export default CustomButton;
